import { render, staticRenderFns } from "./thinking.vue?vue&type=template&id=6730ef8e&"
import script from "./thinking.vue?vue&type=script&lang=js&"
export * from "./thinking.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports